import { addDays, addMonths, endOfDay, startOfDay } from "date-fns";

export const START_OF_TODAY = startOfDay(new Date());
export const END_OF_TODAY = endOfDay(new Date());
export const ONE_WEEK_START = startOfDay(addDays(new Date(), -7));
export const ONE_WEEK_END = endOfDay(addDays(new Date(), 7));
export const ONE_MONTH_START = startOfDay(addMonths(new Date(), -1));
export const ONE_MONTH_END = endOfDay(addMonths(new Date(), 1));

export const TWO_WEEKS_END = endOfDay(addDays(new Date(), 14));
